import { render, staticRenderFns } from "./boot.vue?vue&type=template&id=1db51042"
import script from "./boot.vue?vue&type=script&lang=js"
export * from "./boot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports